<template>
  <div class="dynamic">
    <Headers></Headers>
    <div class="center">
      <img class="center-img" :src="bgUrl" />
      <div class="center-list">
        <h3>{{ listOneTitle }}</h3>
        <div class="list-show"></div>
        <ul>
          <li
            v-for="(item, index) in navData.list"
            :key="index"
            @click="handOneListBut(item.id)"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="list-pages">
          <el-pagination
            small
            @prev-click="onePrevClick"
            @next-click="oneNextClick"
            @current-change="handleOnePageChange"
            layout="prev, pager, next"
            :page-size="1"
            :pager-count="7"
            :total="onePages"
          >
          </el-pagination>
        </div>
      </div>
      <div class="center-list">
        <h3>{{ listTwoTitle }}</h3>
        <div class="list-show"></div>
        <ul>
          <li
            v-for="(item, index) in navDataTwo.list"
            :key="index"
            @click="handOneListBut(item.id)"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="list-pages">
          <el-pagination
            small
            @prev-click="twoPrevClick"
            @next-click="twoNextClick"
            @current-change="handleTwoPageChange"
            layout="prev, pager, next"
            :page-size="1"
            :pager-count="7"
            :total="twoPages"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "dynamic",
  data() {
    return {
      type: "",
      navData: [],
      navDataTwo: [],
      listTitle: [],
      listOneTitle: "",
      listTwoTitle: "",
      onePages: 3, //第一条总页数
      twoPages: 1,
      oneSize: "",
      oneType_id: "",
      twoSize: "",
      twoType_id: "",
      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    handReservationBut() {
      this.$router.push({ name: "Reservation" });
    },
    getNewsTypeData() {},

    async getNewsListData(id) {
      let newsListData = await this.$API.getNewsListData({ type_id: id });
      this.navData = newsListData.data;
      // console.log(newsListData.data);
      this.onePages = newsListData.data.page_sum;
      this.oneCount = newsListData.data.count;
      // console.log(this.oneCount);
      this.oneSize = newsListData.data.page_current;
    },
    async getNewsListTwoData(id) {
      const newsListTwoData = await this.$API.getNewsListData({ type_id: id });
      this.navDataTwo = newsListTwoData.data;
      // console.log(newsListTwoData.data);
      this.twoPages = newsListTwoData.data.page_sum;
      this.twoSize = newsListTwoData.data.page_current;
    },
    async oneNextClick() {
      let current = this.oneSize * 1 + 1;
      let id = this.oneType_id;
      let newsListData = await this.$API.getNewsListData({
        type_id: id,
        page: current,
      });
      this.navData = newsListData.data;
      this.oneSize = newsListData.data.page_current;
    },
    async onePrevClick() {
      let current = this.oneSize * 1 - 1;
      let id = this.oneType_id;
      let newsListData = await this.$API.getNewsListData({
        type_id: id,
        page: current,
      });
      this.navData = newsListData.data;
      this.oneSize = newsListData.data.page_current;
    },
    async handleOnePageChange(v) {
      let id = this.oneType_id;
      let newsListData = await this.$API.getNewsListData({
        type_id: id,
        page: v,
      });
      this.navData = newsListData.data;
      this.oneSize = newsListData.data.page_current;
    },
    async twoNextClick() {
      let current = this.twoSize * 1 + 1;
      let id = this.twoType_id;
      let newsListData = await this.$API.getNewsListData({
        type_id: id,
        page: current,
      });
      this.navDataTwo = newsListData.data;
      this.twoSize = newsListData.data.page_current;
    },
    async twoPrevClick() {
      let current = this.twoSize * 1 - 1;
      let id = this.twoType_id;
      let newsListData = await this.$API.getNewsListData({
        type_id: id,
        page: current,
      });
      this.navDataTwo = newsListData.data;
      this.twoSize = newsListData.data.page_current;
    },
    async handleTwoPageChange(v) {
      let id = this.twoType_id;
      let newsListData = await this.$API.getNewsListData({
        type_id: id,
        page: v,
      });
      this.navDataTwo = newsListData.data;
      this.twoSize = newsListData.data.page_current;
    },
    handOneListBut(id) {
      localStorage.detailsId = id;
      this.$router.push({ name: "DynamicDetails", query: { id: id } });
    },
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_dynamic":
            this.bgUrl = item.image;
            break;
        }
      });
    },
  },
  mounted() {},
  async created() {
    this.onBulist();
    const NewsTypeData = await this.$API.getNewsTypeData({});
    this.listTitle = NewsTypeData.data;
    this.listOneTitle = this.listTitle[0].title;
    this.listTwoTitle = this.listTitle[1].title;
    this.oneType_id = this.listTitle[0].id;
    this.twoType_id = this.listTitle[1].id;
    this.getNewsListData(this.listTitle[0].id);
    this.getNewsListTwoData(this.listTitle[1].id);
    // console.log(this.onePages);
  },
};
</script>
<style lang="sass" scoped>
h3
  font-size: 24px
.list-show
  width: 44px
  height: 5px
  background: #07D1AA
  margin: 20px 0
.dynamic
  .center
    text-align: left
    padding-top: 50px
    img
      width: 100%
    .center-list
      margin: 20px
      padding: 20px 0
      ul
        li
          color: #5C5C5C
          // line-height: 40px
          padding: 10px 0
          font-size: 14px
      .list-pages
        margin-top: 30px
        text-align: center
</style>

